import { render, staticRenderFns } from "./TreeMenu.vue?vue&type=template&id=adc6d1e2&scoped=true&"
import script from "./TreeMenu.vue?vue&type=script&lang=ts&"
export * from "./TreeMenu.vue?vue&type=script&lang=ts&"
import style0 from "./TreeMenu.vue?vue&type=style&index=0&id=adc6d1e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc6d1e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBtn,VIcon,VTooltip,VTreeview})
